import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();
  const intl = useIntl();
  const primaryAny = theme.palette.primary as unknown as Record<string, string>;
  const brandOlive = primaryAny['700'] ?? theme.palette.primary.dark;
  const ariaLabel = intl.formatMessage({ id: 'app.brand.full' });

  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel}>
      <rect x="1" y="1" width="32" height="32" rx="10" fill={brandOlive} />
      <rect x="10" y="10" width="5.5" height="5.5" rx="1.5" fill="white" />
      <rect x="18.5" y="10" width="5.5" height="5.5" rx="1.5" fill="white" />
      <rect x="10" y="18.5" width="5.5" height="5.5" rx="1.5" fill="white" />
      <rect x="18.5" y="18.5" width="5.5" height="5.5" rx="1.5" fill="white" />
    </svg>
  );
}
